<template>
  <b-modal 
    v-model="showModal"
    :title="noMatchTitle"
    centered
    ok-title="Confirm No Match"
    cancel-title="Cancel"
    @ok="submitNoMatch"
    @cancel="handleCancel"
    @hide="handleHide">
    Are you sure &quot;{{ bioreqDocument.title }}&quot; is not a match?
  </b-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    bioreqDocument: {
      type: Object,
      required: true,
      default: null
    }
  },
  data() {
    return {
      modalIsVisible: false
    }
  },
  computed: {
    showModal: {
      get () {
        return this.visible
      },
      set (newValue) {
        this.modalIsVisible = newValue
      }
    },
    noMatchTitle () {
      return `Confirm No Match - ${this.bioreqDocument.title}`
    }
  },
  methods: {
    submitNoMatch (evt) {
      evt.preventDefault()
      this.$store.dispatch('bioreq/noMatch', this.bioreqDocument.id)
      this.$emit('hide-no-match-modal')
    },
    handleCancel () {
      this.$emit('hide-no-match-modal')
    },
    handleHide () {
      this.$emit('hide-no-match-modal')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/admin/bioreq/noMatchModal.vue